import { mapActions } from "vuex";

export default  {
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarForm()
		{
			
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{	
						case 'btn0' : 
						   	let ids = []
							for (let i = 0; i < this.dataForm[this.namePath].datos_afiliado.length; i++) {
								ids.push(this.dataForm[this.namePath].datos_afiliado[i].id)
								
							}
							window.open( this.url+'/api/pdf/cuentas?ids='+ids.toString()+'&mes='+this.mesPeriodo.id+'&ano='+this.anoPeriodo.id+'&tipo='+this.nameSearchs+'-'+this.searchSw.value+'&token='+this.token)				
							return true

						break				
						case 'afiliadoFtn' :
							this.getBackendData=true
							let totalAfl = 0
							this.resetDataForm({state: 'servicios_activos'}) 

							for(let i=0;i<this.dataMultiple[this.namePath].multiple_servicios.length;i++)
							{
								if(this.dataMultiple[this.namePath].multiple_servicios[i].check===1)
								{				
									let newValue= this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
									totalAfl=totalAfl+this.dataMultiple[this.namePath].multiple_servicios[i].valor
									this.pushDataForm({state:  'servicios_activos', data: newValue})										
								}   
							}
							let aporteRegistrado = await this.getData({route: 'get_aporteregistrado', data: {razon: this.dataForm[this.namePath].info_afiliacion.id_datos_razon, afiliado: this.dataForm[this.namePath].datos_afiliado.id, mes: this.dataForm[this.namePath].info_afiliacion.mes_periodo,ano: this.dataForm[this.namePath].info_afiliacion.ano_periodo}})
							
							if(aporteRegistrado.archivo_plano===null)
							{
								await this.updateGlobal({state: 'openModal/modal',  data: 
									{ value: true, title: 'Registrar Aporte', modal: 'Aportes', loaded: false, data: {novedad: this.novedad} } })
							}
							else 
							{
								this.showAporteRegistrado=true
								this.linkaporte=this.url+'/api/pdf/registroaportes?id='+aporteRegistrado.archivo_plano.id_info_aportes.toString()+'&token='+this.token				
						
							}
							this.getBackendData=false
							return true
						break
						case 'aportesFtn': 
							await this.updateDataPost({ data: {
								data: [],
								tablaPost:['info_aportes','datos_afiliado','info_afiliacion','aportes_registro','archivo_plano','servicios_activos'],
								tablaDelete: [],
								tablaAuditar: true, 
								route: 'save_all'
							}})
						break
						case 'aportesGrupalFtn':
							await this.updateDataPost({ state: 'tablaPost', data: ['info_aportes','datos_afiliado','info_afiliacion','aportes_registro','archivo_plano','servicios_activos']})
							await this.updateDataPost({ state: 'tablaDelete', data: []})
							await this.updateDataPost({ state: 'route', data: 'save_all'})
							event.savePost=true
						break
						case 'editarAportesFtn':
							await this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado','info_afiliacion','servicios_activos']})
							await this.updateDataPost({ state: 'tablaDelete', data: []})
							await this.updateDataPost({ state: 'route', data: 'save_all'})
						break

					}
				}

				let dataSave = await this.save(event.save,event.savePost)
				
				if(dataSave.error===false)
				{				
					if(event.ftn!==undefined)
					{
						switch(event.ftn)
						{
							case 'aportesFtn':	
								window.open( this.url+'/api/pdf/registroaportes?id='+dataSave.ids.info_aportes.toString()+'&token='+this.token,'_blank')				
							break;
							case 'aportesGrupalFtn':	
								window.open( this.url+'/api/pdf/registroaportes?id='+dataSave.ids.info_aportes.toString()+'&token='+this.token,'_blank')				
							break;
							case 'editarAportesFtn': 							
								let data= {
									datos_afiliado: this.dataForm[this.namePath].datos_afiliado,
									info_afiliacion: this.dataForm[this.namePath].info_afiliacion,
									servicios_activos: this.dataForm[this.namePath].servicios_activos,
									servicios_nuevos:  this.dataForm[this.namePath].servicios_nuevos
								}
								this.$set(this.dataGet[this.namePath].data,this.dataIndex[this.namePath],data)
							break
						}
					}
					
					if(event.ftn!=='editarAportesFtn')
					{
						await this.limpiarSearchs()	
					}
					
					const await01 = this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})
					const await02 = this.resetDataIndex()
					const await03 = this.resetGlobal({state: 'openModal'})
					const await04 = this.resetGlobal({state: 'saveConfig/capa'})
					const await05 = this.resetDataForm()
					const await06 = this.onInit()

					await Promise.all([await01,await02,await03,await04,await05,await06])

					return true
				}
				else 
				{					
					const await00 = this.resetGlobal({state: 'saveConfig/capa'})
					const await01 = this.resetDataPost({state: 'data'}) 
					await Promise.all([await00,await01])
				}
			}
			catch(e){
				console.log('error save aportes registro')

			}			
		}		
	},
}
